/**
 * FaceFrame Component
 * Visual guide overlay for face positioning during webcam capture
 */

import React from "react";
import { cn } from "../../utils";

interface FaceFrameProps {
  className?: string;
  size?: "small" | "medium" | "large";
}

export const FaceFrame: React.FC<FaceFrameProps> = ({
  className,
  size = "medium",
}) => {
  const sizeClasses = {
    small: "w-32 h-40",
    medium: "w-48 h-60",
    large: "w-64 h-80",
  };

  const cornerSize = {
    small: "w-5 h-5 border-2",
    medium: "w-6 h-6 border-[3px]",
    large: "w-8 h-8 border-4",
  };

  return (
    <div
      className={cn(
        "absolute inset-0 flex items-center justify-center pointer-events-none",
        className
      )}
    >
      <div className={cn("relative", sizeClasses[size])}>
        {/* Top-left corner */}
        <div
          className={cn(
            "absolute top-0 left-0 border-t border-l border-cyan-400 rounded-tl-lg",
            cornerSize[size]
          )}
        />

        {/* Top-right corner */}
        <div
          className={cn(
            "absolute top-0 right-0 border-t border-r border-cyan-400 rounded-tr-lg",
            cornerSize[size]
          )}
        />

        {/* Bottom-left corner */}
        <div
          className={cn(
            "absolute bottom-0 left-0 border-b border-l border-cyan-400 rounded-bl-lg",
            cornerSize[size]
          )}
        />

        {/* Bottom-right corner */}
        <div
          className={cn(
            "absolute bottom-0 right-0 border-b border-r border-cyan-400 rounded-br-lg",
            cornerSize[size]
          )}
        />
      </div>
    </div>
  );
};
